<div [ngClass]="{'extra-padding' : isModal}">

  <div *ngIf="isModal">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span class="hubtiger-close"></span>
    </button>
  </div>

  <div class="label header" [ngClass]="{'red bold': !isValid()}">{{ 'bikeshop.rentals.products.log_usage_reading' |
    translate }}</div>
  <div *ngFor="let record of serviceIndicatorRecords" class="row margin-top-16">
    <div class="col-md-3">
      <div class="bold">{{ record.brand }} {{ record.model }}</div>
      <div class="info">{{ record.serialNumber }}</div>
    </div>
    <div class="col-md-4">
      <div class="p-inputgroup">
        <input type="number" pInputText
          [ngClass]="{'invalid': record.absoluteValue == null || record.absoluteValue < 0}"
          [(ngModel)]="record.absoluteValue" 
          (keyup.enter)="updateServiceIndicatorRecord(record)"
          (focusout)="updateServiceIndicatorRecord(record)"
          [disabled]="record.updated"
          [placeholder]="record.metric === 'Mileage' ? ('bikeshop.rentals.products.enter_current_mileage' | translate) : ('bikeshop.rentals.products.enter_current_hours' | translate)"
          [min]="record.previousRecord && record.previousRecord.length > 0 ? record.previousRecord[0].absoluteValue || record.previousRecord[0].valueApplied : 0" />
        <span class="p-inputgroup-addon">
          {{ record.metric === 'Mileage' ? (partnerData?.DefaultUnitOfMeasure == 1 ? 'Kms' : 'Miles') :
          ('bikeshop.rentals.booking.hours' | translate) }}
        </span>
      </div>
    </div>
    
    <div class="col-md-1 label" style="margin-top: 10px;">
      <i class="fa fa-check"
        [ngClass]="{ red: !record.absoluteValue || record.absoluteValue < 0, 'green' : record.updated }"></i>
    </div>
    <div class="col-md-4" *ngIf="record.previousRecord && record.previousRecord.length > 0">
      <div class="label">{{ 'bikeshop.rentals.products.previous_value' | translate }}:</div>
      <div class="info">
        {{ record.previousRecord[0].absoluteValue || record.previousRecord[0].valueApplied }}
        <span *ngIf="record.metric === 'Mileage'">
          {{ partnerData?.DefaultUnitOfMeasure == 1 ? 'Kms' : 'Miles' }}
        </span>
        <span *ngIf="record.metric === 'Hours'">
          {{ 'bikeshop.rentals.booking.hours' | translate }}
        </span>
        <span class="small-text" *ngIf="record.previousRecord[0].previousDate">
          ({{ record.previousRecord[0].previousDate | date:'mediumDate' }})
        </span>
      </div>
    </div>
    <div class="col-md-4" *ngIf="!(record.previousRecord && record.previousRecord.length > 0)">
      <div class="label">{{ 'bikeshop.rentals.products.no_previous_value' | translate }}</div>
    </div>
  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast" key="service-indicator-update"></p-toast>